import { useCallback, useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { ValidateCode } from "@/shared/ui";
import { AdditionalFlow } from "@/domains/auth/constants/additionalFlow";
import useResetPasswordEmailCode from "@/domains/auth/hooks/reset-password/useResetPasswordEmailCode";
import useGetCodeTimer from "@/domains/auth/hooks/useGetCodeTimer";
import { useAuthFlow } from "@/domains/auth/containers/context";

type Props = {
  address: string;
};

export default function AuthResetPasswordCheckEmailCodeContainer({ address }: Props) {
  const { openOnly } = useAuthFlow();
  const {
    sendError,
    sendCodeHandler,
    sendIsPending,
    checkCodeHandler,
    checkIsCompleted,
    checkIsPending,
    checkError,
  } = useResetPasswordEmailCode();
  const [code, setCode] = useState<string>("");

  const { getTimer, timer } = useGetCodeTimer();

  useEffect(() => {
    getTimer({ type: "email", payload: address });
  }, []);

  const onSubmit = useCallback(() => {
    checkCodeHandler(code);
  }, [checkCodeHandler, code]);

  const onSendCodeHandler = useCallback(async () => {
    if (address) {
      await sendCodeHandler(address);
      await getTimer({ type: "email", payload: address });
    }
  }, [address, sendCodeHandler]);

  useEffect(() => {
    if (checkIsCompleted) {
      openOnly(AdditionalFlow.AuthUpdatePassword);
    }
  }, [checkIsCompleted, openOnly]);

  return (
    <FocusLock className="contents">
      <ValidateCode
        address={address}
        type={TfaMethod.EMAIL}
        code={code}
        onCodeChange={setCode}
        onSubmit={onSubmit}
        onSendCode={onSendCodeHandler}
        pending={checkIsPending}
        error={checkError || sendError}
        sendCodePending={sendIsPending}
        timer={timer}
      />
    </FocusLock>
  );
}
